'use client';

import { c as _c } from "react/compiler-runtime";
import headerIcon from '@images/svg/header-ru.svg';
import ROUTES from '@lib/constants/routes';
import { handleOpenMenu } from '@lib/store/slices/ComponentsSlice';
import classNames from 'classnames';
import Link from 'next/link';
import SVG from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';
import style from './HeaderLogo.module.scss';
function HeaderLogo(t0) {
  const $ = _c(18);
  const {
    color,
    handleScrollTop,
    openModelForm
  } = t0;
  const dispatch = useDispatch();
  const headerKeysData = useSelector(_temp);
  const headerKeysValues = headerKeysData && headerKeysData.menuItems?.length > 0 && headerKeysData.menuItems[0];
  let t1;
  if ($[0] !== color || $[1] !== dispatch || $[2] !== handleScrollTop || $[3] !== headerKeysData || $[4] !== headerKeysValues?.path || $[5] !== headerKeysValues?.value || $[6] !== openModelForm) {
    t1 = color && handleScrollTop && <div className={style.headerLogo}>{!openModelForm && <div className={style.svgburger} onClick={() => dispatch(handleOpenMenu(true))} role="button" tabIndex="0"><svg width="32" height="9" viewBox="0 0 32 9" fill="none"><rect x="10" width="22" height="2" rx="1" fill={color} /><rect y="7" width="32" height="2" rx="1" fill={color} /></svg></div>}<Link href={ROUTES.root} onClick={() => handleScrollTop()} aria-label={"\u041C\u043E\u043C\u0435\u043D\u0442\u0441 \u2013 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0431\u0438\u0437\u043D\u0435\u0441-\u043A\u043B\u0430\u0441\u0441\u0430 \u043E\u0442 Forma"}><SVG src={headerIcon.src} className={style.svglogo} fill={color} /></Link>{headerKeysData && !headerKeysData?.hidden && <Link href={headerKeysValues?.path} className={classNames(style.link, {
        [style.link__grey]: color !== "white"
      })}>{headerKeysValues?.value}</Link>}</div>;
    $[0] = color;
    $[1] = dispatch;
    $[2] = handleScrollTop;
    $[3] = headerKeysData;
    $[4] = headerKeysValues?.path;
    $[5] = headerKeysValues?.value;
    $[6] = openModelForm;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== color || $[9] !== handleScrollTop) {
    t2 = !color && handleScrollTop && <Link href={ROUTES.root} onClick={() => handleScrollTop()} aria-label={"\u041C\u043E\u043C\u0435\u043D\u0442\u0441 \u2013 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0431\u0438\u0437\u043D\u0435\u0441-\u043A\u043B\u0430\u0441\u0441\u0430 \u043E\u0442 Forma"}><SVG src={headerIcon.src} className={style.svglogo} fill="white" /></Link>;
    $[8] = color;
    $[9] = handleScrollTop;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== color || $[12] !== handleScrollTop) {
    t3 = !color && !handleScrollTop && <Link href={ROUTES.root} aria-label={"\u041C\u043E\u043C\u0435\u043D\u0442\u0441 \u2013 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0431\u0438\u0437\u043D\u0435\u0441-\u043A\u043B\u0430\u0441\u0441\u0430 \u043E\u0442 Forma"}><SVG src={headerIcon.src} className={style.svglogo} fill="white" /></Link>;
    $[11] = color;
    $[12] = handleScrollTop;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
function _temp(state) {
  return state.projectinfo?.headerKeysData;
}
export default HeaderLogo;